import { convertSimNaoEnumToBoolean } from '@mchat-rf/consulta-seguimento/converter-consultaSeguimento'
import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { ConsultaSeguimentoPergunta17Model } from './model-consultaSeguimentoPergunta17'

export const convertConsultaSeguimentoPergunta17ToInput = (
  value: ConsultaSeguimentoPergunta17Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_17_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_17_TENTA_FAZER_QUE_OLHE?.FALA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_17_TENTA_FAZER_QUE_OLHE?.EMITE_SOM_OU_BARULHO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_17_TENTA_FAZER_QUE_OLHE?.OLHA_PARA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_17_TENTA_FAZER_QUE_OLHE?.CONTINUA_OLHANDO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_17_06,
      stResposta: convertSimNaoEnumToBoolean(value.OUTRO?.radioValue),
      outros: value.OUTRO?.textValue,
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
